module.exports = __webpack_public_path__ + "img/start.e0e2da96.webp";